import type { CommunicationChannel } from '../../../../services/communications';
import { CHANNELS } from './channels';

interface ChannelSegmentedControlProps {
    value: CommunicationChannel;
    onChange: (channel: CommunicationChannel) => void;
    disabled?: boolean;
}

// The entry's channel picker - a five-tile radio grid shaping the rest of
// the entry section (see channels.ts). Shared by the create page and
// EntryComposer.tsx.
export function ChannelSegmentedControl({
    value,
    onChange,
    disabled = false
}: ChannelSegmentedControlProps) {
    return (
        <div role="radiogroup" aria-label="Channel" className="grid grid-cols-5 gap-2">
            {CHANNELS.map((channel) => {
                const Icon = channel.icon;
                const isActive = channel.id === value;
                return (
                    <button
                        key={channel.id}
                        type="button"
                        role="radio"
                        aria-checked={isActive}
                        disabled={disabled}
                        onClick={() => onChange(channel.id)}
                        className={`h-11 rounded-xl border px-3 flex items-center justify-start gap-2 text-left transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
                            isActive
                                ? 'border-gray-800 bg-white'
                                : 'border-gray-200 bg-white hover:border-gray-400'
                        }`}
                    >
                        <span
                            className="w-6 h-6 rounded-lg flex items-center justify-center shrink-0"
                            style={{
                                background: isActive ? channel.soft : '#F3F4F6',
                                color: isActive ? channel.tone : '#9CA3AF'
                            }}
                        >
                            <Icon className="h-3.5 w-3.5" />
                        </span>
                        <span
                            className={`text-[13px] truncate min-w-0 ${
                                isActive ? 'font-bold text-gray-900' : 'font-semibold text-gray-600'
                            }`}
                        >
                            {channel.label}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}
